import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/i18n";
import { api } from "@/lib/api";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import BlogPage from "@/pages/BlogPage";
import PostPage from "@/pages/PostPage";

function App() {
    useEffect(() => {
        api.get("/settings")
            .then(({ data }) => {
                if (data.ga_id && !document.getElementById("ga-script")) {
                    const s = document.createElement("script");
                    s.id = "ga-script";
                    s.async = true;
                    s.src = `https://www.googletagmanager.com/gtag/js?id=${data.ga_id}`;
                    document.head.appendChild(s);
                    window.dataLayer = window.dataLayer || [];
                    window.gtag = function () { window.dataLayer.push(arguments); };
                    window.gtag("js", new Date());
                    window.gtag("config", data.ga_id);
                }
                if (data.gsc_verification && !document.querySelector('meta[name="google-site-verification"]')) {
                    const m = document.createElement("meta");
                    m.name = "google-site-verification";
                    m.content = data.gsc_verification;
                    document.head.appendChild(m);
                }
                if (data.bg_color || data.accent_color) {
                    document.getElementById("custom-theme-overrides")?.remove();
                    const st = document.createElement("style");
                    st.id = "custom-theme-overrides";
                    let css = "";
                    if (data.bg_color) css += `body{background-color:${data.bg_color}!important}`;
                    if (data.accent_color)
                        css += `.text-amber-400,.text-amber-300{color:${data.accent_color}!important}.bg-amber-400{background-color:${data.accent_color}!important}.border-amber-400{border-color:${data.accent_color}!important}`;
                    st.textContent = css;
                    document.head.appendChild(st);
                }
            })
            .catch(() => {});
    }, []);

    return (
        <div className="App">
            <LanguageProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/admin" element={<AdminPage />} />
                        <Route path="/blog" element={<BlogPage />} />
                        <Route path="/blog/:slug" element={<PostPage />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-center" richColors dir="rtl" />
            </LanguageProvider>
        </div>
    );
}

export default App;
